import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useApi from '../../hooks/api';
import { Event } from '../../types';

type Events = {
	events: Event[]
};

const EventList = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
	const name = i18n.language === 'en' ? 'name_en' : 'name_ru';
	const [ data, error, isLoading ] = useApi('get', '/events');

	if(isLoading) return <div>{t('common.loading')}</div>;
	if(error) return <div className='error'>{error.text[lang]}</div>;
	if(!data) return <div className='error'>No data</div>;

	return (
		<ul>
			{(data as Events).events.map(event => (
				<li key={event.id}>
					<Link to={'/client/' + event.slug}>{event[name]}</Link> ({event.slug})
				</li>
			))}
		</ul>
	);
};

export default EventList;
